// Anti Aging Bundle Live Orders Popup JavaScript
(function() {
  // Array of sample orders
  const orders = [
    { name: "John", location: "NY", product: "Anti Aging Bundle", time: "14 minutes ago" },
    { name: "Alex", location: "FL", product: "Anti Aging Bundle", time: "15 minutes ago" },
    { name: "Benjamin", location: "MA", product: "Anti Aging Bundle", time: "28 minutes ago" },
    { name: "Norma", location: "TX", product: "Anti Aging Bundle", time: "41 minutes ago" },
    { name: "Craig", location: "NY", product: "Anti Aging Bundle", time: "55 minutes ago" },
    { name: "Krystel", location: "FL", product: "Anti Aging Bundle", time: "1 hour 9 minutes ago" },
    { name: "Alicia", location: "UT", product: "Anti Aging Bundle", time: "1 hour 23 minutes ago" },
    { name: "Brandon", location: "MI", product: "Anti Aging Bundle", time: "12 minutes ago" },
    { name: "Em", location: "NC", product: "Anti Aging Bundle", time: "26 minutes ago" },
    { name: "Deshawn", location: "GA", product: "Anti Aging Bundle", time: "41 minutes ago" },
    { name: "David", location: "CA", product: "Anti Aging Bundle", time: "56 minutes ago" },
    { name: "Fabiola", location: "IL", product: "Anti Aging Bundle", time: "1 hour 12 minutes ago" },
    { name: "Miranda", location: "AR", product: "Anti Aging Bundle", time: "1 hour 29 minutes ago" },
    { name: "Andrea", location: "FL", product: "Anti Aging Bundle", time: "1 hour 47 minutes ago" },
    { name: "Valeriya", location: "IL", product: "Anti Aging Bundle", time: "2 hours 6 minutes ago" },
    { name: "Ada", location: "AZ", product: "Anti Aging Bundle", time: "2 hours 26 minutes ago" },
    { name: "Maria", location: "IL", product: "Anti Aging Bundle", time: "2 hours 47 minutes ago" },
    { name: "Alfred", location: "TX", product: "Anti Aging Bundle", time: "3 hours 9 minutes ago" },
    { name: "Kelly", location: "AZ", product: "Anti Aging Bundle", time: "3 hours 32 minutes ago" },
    { name: "Desiree", location: "FL", product: "Anti Aging Bundle", time: "3 hours 56 minutes ago" },
    { name: "Ryan", location: "CA", product: "Anti Aging Bundle", time: "4 hours 21 minutes ago" },
    { name: "Eduardo", location: "FL", product: "Anti Aging Bundle", time: "4 hours 47 minutes ago" },
    { name: "Olimpia", location: "TX", product: "Anti Aging Bundle", time: "11 minutes ago" },
    { name: "Jaymari", location: "NJ", product: "Anti Aging Bundle", time: "25 minutes ago" },
    { name: "Bernardo", location: "MD", product: "Anti Aging Bundle", time: "40 minutes ago" },
    { name: "Loleta", location: "MT", product: "Anti Aging Bundle", time: "56 minutes ago" },
    { name: "Makaila", location: "MO", product: "Anti Aging Bundle", time: "1 hour 13 minutes ago" },
    { name: "Amelia", location: "VA", product: "Anti Aging Bundle", time: "1 hour 31 minutes ago" },
    { name: "Patricia", location: "CA", product: "Anti Aging Bundle", time: "1 hour 50 minutes ago" },
    { name: "Brandon", location: "MI", product: "Anti Aging Bundle", time: "2 hours 10 minutes ago" }
  ];

  // Display popup function
  function showLiveOrder() {
    const randomOrder = orders[Math.floor(Math.random() * orders.length)];
    const popup = document.getElementById('live-orders-popup');
    popup.innerHTML = `
      <div class="popup-content">
        <div class="popup-image">
          <img style="border-radius: 5px;" src="https://cdn.shopify.com/s/files/1/2443/2395/files/The_Anti_Aging_Bundle_Zoom.png?v=1733434944" alt="Product Image">
          <span class="glow-dot"></span>
        </div>
        <div class="popup-text">
          <div class="popup-line">
            <div class="name-location"><strong>${randomOrder.name} from ${randomOrder.location}</strong></div>
          </div>
          <div class="popup-line product-name"><span class="ordered-text">ordered</span> <strong><span class="product-text">${randomOrder.product}</span></strong></div>
          <div class="popup-line order-time">${randomOrder.time}</div>
          <div class="verified-buyer-badge">Verified Buyer</div>
        </div>
      </div>
    `;
    popup.style.display = 'block';

    setTimeout(() => {
      popup.classList.add('popup-hide');
    }, 6000); // Show for 5 seconds

    setTimeout(() => {
      popup.style.display = 'none';
      popup.classList.remove('popup-hide');
      setTimeout(showLiveOrder, getRandomTimeInterval());
    }, 6500);
  }

  // Random time intervals between popups
  function getRandomTimeInterval() {
    const intervals = [20000, 20000, 20000]; // 20s, 20s, 20s
    return intervals[Math.floor(Math.random() * intervals.length)];
  }

  // Start the popup display
  document.addEventListener('DOMContentLoaded', () => {
    setTimeout(showLiveOrder, getRandomTimeInterval());
  });
})();
